import * as React from "react";

// Port of shadcn's Input — same pattern as button.jsx (no cn() helper, plain concatenation).
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  const classes = `flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50${className ? ` ${className}` : ""}`;
  return <input type={type} className={classes} ref={ref} {...props} />;
});
Input.displayName = "Input";

export { Input };
